<template>
  <section>
    <v-container fluid>
      <v-row class="justify-end align-center">
        <v-col cols="12" md="auto">
          <v-btn class="accent shadow-4 px-8" @click="openForm()" large rounded>
            Añadir Estado
          </v-btn>
        </v-col>
        <v-col cols="auto" class="ml-auto">
          <v-text-field
            filled
            rounded
            dense
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="shadow-1">
      <!-- NO TOCAR. ESTA PAGINACIÓN POR SERVIDOR SI FUNCIONA -->
      <v-data-table
        :search="search"
        :headers="headers"
        :items="RegisterStatusList"
        item-key="id"
        :loading="isLoading"
        :options.sync="options"
        :server-items-length="totalItems"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100],
        }"
      >
        <template v-slot:[`item.call_on`]="{ item }">
          <v-icon
            x-small
            class="mr-2"
            :color="item.call_on == 1 ? 'info' : 'grey'"
          >
            {{ item.call_on == 1 ? "mdi-thumb-up" : "mdi-thumb-down" }}
          </v-icon>
          {{ item.call_on == 1 ? "Sí" : "No" }}
        </template>

        <template v-slot:[`item.priority`]="{ item }">
          <!-- <v-icon
            small
            class="mr-2"
            :color="item.priority == 0 ? 'success' : 'error'"
          >
            {{ item.priority == 1 ? "mdi-arrow-up" : "mdi-arrow-down" }}
          </v-icon> -->
          {{ item.priority }}
          <!-- {{ item.priority == 1 ? "Alta" : "Baja" }} -->
        </template>

        <!-- <template v-slot:[`item.status`]="{ item }">
          <v-tooltip color="blue-grey" top>
            <template v-slot:activator="{ on }">
              <v-chip
                v-on="on"
                color="transparent"
                small
                @click="changeStatus(item)"
              >
                <v-icon left small :color="statusColor(item.status)"
                  >mdi-radiobox-marked</v-icon
                >
                {{ item.status | StatusName }}
              </v-chip>
            </template>
            <span>Cambiar estado</span>
          </v-tooltip>
        </template> -->

        <template v-slot:[`item.created_at`]="{ item }">
          <span>{{ dateFormat(item.created_at) }}</span>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              icon
              :color="hover ? 'accent' : 'blue-grey'"
              @click.stop="openForm(true, item)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-hover>

          <!-- <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              icon
              :color="hover ? 'error' : 'blue-grey'"
              @click.stop="handleDelete(item)"
            >
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </v-hover> -->
        </template>
      </v-data-table>
    </v-card>

    <!-- Componentes -->
    <CreateDialog
      v-if="formDialog"
      :dialog="formDialog"
      :editMode="editMode"
      :data="itemToEdit"
      :axios="$axios"
      @dialog:close="callbackForm"
    ></CreateDialog>
  </section>
</template>

<script>
import axios from "axios";
import CreateDialog from "@/components/RegisterState/Create.vue";

export default {
  name: "AgentList",

  components: {
    CreateDialog,
  },

  data() {
    return {
      isLoading: false,
      search: "",
      // For pagination
      totalItems: 0,
      options: {
        page: 1,
        itemsPerPage: 15,
      },
      // End for pagination
      RegisterStatusList: [],
      headers: [
        {
          text: "Nombre tipificación",
          align: "left",
          value: "name",
          class: "primary--text",
          width: "30%",
        },
        {
          text: "Marcar",
          value: "call_on",
          class: "primary--text",
          width: "15%",
        },
        {
          text: "Prioridad",
          value: "priority",
          class: "primary--text",
          width: "15%",
        },
        // {
        //   text: "Creado",
        //   value: "created_at",
        //   class: "primary--text",
        //   width: "15%",
        // },
        {
          text: "Acciones",
          value: "action",
          class: "primary--text",
          width: "15%",
          align: "left",
          sortable: false,
        },
      ],
      formDialog: false,
      $axios: null,
      itemToEdit: null,
    };
  },

  watch: {
    options: {
      handler() {
        this.getRegisterStatus();
      },
      deep: true,
    },
  },

  created() {
    const token = localStorage.getItem("token");
    this.$axios = axios.create({
      baseURL: process.env.VUE_APP_ROOTAPI,
      headers: { Authorization: `Bearer ${token}` },
    });

    this.getRegisterStatus();
  },

  methods: {
    dateFormat(date) {
      const dateFormatted = date
        .toString()
        .slice(0, 10)
        .split("-")
        .reverse()
        .join("/");
      return dateFormatted;
    },

    /**
     * Busca la lista de registros
     *
     * @param {Number} page - Numero de pagina a mostrar
     */
    async getRegisterStatus() {
      this.isLoading = true;

      try {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options;

        const { data } = await this.$axios.get(`/campaign/register_status`, {
          params: { page, itemPerPage: itemsPerPage, prioritySort: sortDesc },
        });
        // console.log(data);
        this.RegisterStatusList = data.data;
        this.totalItems = data.total;
      } catch (error) {
        this.$snotify.error(error.response.data.error, "¡Error!");
      } finally {
        this.isLoading = false;
      }
    },

    openForm(editMode = false, item = null) {
      this.editMode = editMode;
      if (editMode) this.itemToEdit = JSON.parse(JSON.stringify(item));
      this.formDialog = true;
    },

    callbackForm(item = null) {
      if (item && !this.editMode)
        this.RegisterStatusList = [...this.RegisterStatusList, item];
      if (item && this.editMode)
        this.RegisterStatusList = this.RegisterStatusList.map((el) =>
          el.id === item.id ? item : el
        );
      this.formDialog = false;
      this.editMode = false;
    },
  },
};
</script>
